export const nhomKhachHang = {
  sections: { list: { title: 'Customer groups' } },
  filter: {
    searchPlaceholder: 'Search by code, name, note',
    textDetailTitle: 'Advanced filters',
    statusSection: 'Status',
    sortSection: 'Sort',
    sortField: 'Sort by',
    sortDir: 'Sort direction',
  },
  status: {
    all: 'All',
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  sort: {
    ngayTao: 'Created date',
    ma: 'Group code',
    tenNhom: 'Group name',
  },
  filters: {
    groupTreeSection: 'Customer groups',
    treeAll: 'All groups',
    treeSearch: 'Search customer groups',
  },
  fields: {
    code: 'Group code',
    name: 'Group name',
    note: 'Note',
    createdAt: 'Created',
    updatedAt: 'Updated',
    actions: 'Actions',
  },
  titles: { add: 'Add customer group', edit: 'Edit customer group' },
  actions: {
    quickAdd: 'Quick add customer group',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load list',
    createSuccess: 'Customer group created',
    updateSuccess: 'Customer group updated',
    deleteSuccess: 'Customer group deleted',
    notFound: 'Group not found',
    confirmDelete: 'Delete group «{name}»?',
    listSummary: 'Total {count} customer groups',
    selectedCount: 'Selected: {count}',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm:
      'Delete {count} selected customer group(s)? (Each group is deleted via a separate API call.)',
    bulkDeleteSuccess: 'Deleted {count} customer group(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No groups selected',
  },
  validation: {
    maRequired: 'Please enter the group code',
    maInvalid: 'Group code may only contain letters, digits, hyphen (-) or underscore (_), without spaces',
    tenRequired: 'Please enter the group name',
  },
  import: {
    description: 'Select an Excel (.xlsx) file: Group code, Name, Note, Status.',
    success: 'Customer groups imported successfully',
    failed: 'Customer group import failed',
    noData: 'No valid data rows in file',
  },
}
